import React from "react";
import { Col, Row, Timeline } from "antd";
import { LoadTimeSlotMap } from "@/utils/enum";
import { getGuidFirst8 } from "@/utils/utils";

const ConfirmForDispatchBody = ({
  shipmentsList,
  selectedTransporterEntityId,
  selectedTransporterUserId,
  transporterUsersList,
  transporterEntitiesList,
}) => {
  const user = transporterUsersList?.find(u => u.userId === selectedTransporterUserId);

  const companyName = transporterEntitiesList?.find(e => e.id === selectedTransporterEntityId)?.name ?? "";

  const renderTimeLineItems = () => {
    const timeLineItems = [];

    shipmentsList.forEach(s => {
      timeLineItems.push({
        shipmentId: s.id,
        key: `${s.id}-pickup`,
        date: s.pickupETADate,
        timeSlotIndex: s.pickupETATimeSlotIndex,
        description: `Pickup at ${s.pickupAddress.simplifyAddress} on ${s.pickupETADate.format("MM/DD/YYYY")} between ${
          LoadTimeSlotMap[s.pickupETATimeSlotIndex]
        }`,
      });

      timeLineItems.push({
        shipmentId: s.id,
        key: `${s.id}-dropoff`,
        date: s.dropoffETADate,
        timeSlotIndex: s.dropoffTimeSlotIndex,
        description: `Dropoff at ${s.dropOffAddress.simplifyAddress} on ${s.dropoffETADate.format(
          "MM/DD/YYYY",
        )} between ${LoadTimeSlotMap[s.dropoffETATimeSlotIndex]}`,
      });

      if (s.userAcceptedExchangeOffer) {
        const exchangeId = s.childShipmentId || s.parentShipmentId;

        timeLineItems.push({
          shipmentId: exchangeId,
          key: `${exchangeId}-pickup`,
          date: s.exchangePickupETADate,
          timeSlotIndex: s.exchangePickupTimeSlotIndex,
          description: `Pickup at ${s.dropOffAddress.simplifyAddress} on ${s.exchangePickupETADate.format(
            "MM/DD/YYYY",
          )} between ${LoadTimeSlotMap[`${s.exchangePickupETATimeSlotIndex}`]}`,
        });

        timeLineItems.push({
          shipmentId: exchangeId,
          key: `${exchangeId}-dropoff`,
          date: s.exchangeDropoffETADate,
          timeSlotIndex: s.exchangeDropoffTimeSlotIndex,
          description: `Dropoff at ${s.pickupAddress.simplifyAddress} on ${s.exchangeDropoffETADate.format(
            "MM/DD/YYYY",
          )} between ${LoadTimeSlotMap[`${s.exchangeDropoffETATimeSlotIndex}`]}`,
        });
      }
    });

    // Sort time line items in chronological order
    timeLineItems.sort((item1, item2) => {
      const isSameDay = item1.date.isSame(item2.date, "day");

      if (isSameDay) {
        return item1.timeSlotIndex < item2.timeSlotIndex ? -1 : 1;
      }

      return item1.date.isBefore(item2.date) ? -1 : 1;
    });

    return timeLineItems.map(item => {
      return (
        <Timeline.Item key={item.key}>
          <strong>{getGuidFirst8(item.shipmentId)}</strong>
          <span>{` - ${item.description}`}</span>
        </Timeline.Item>
      );
    });
  };

  return (
    <Row
      style={{
        border: "1px solid #d9d9d9",
        padding: "2%",
      }}
    >
      <Col flex={2}>
        <div style={{ fontWeight: "bold", fontSize: 20, marginBottom: 16 }}>Dispatch Timeline</div>
        <Timeline style={{ height: 300, overflowY: "auto", paddingTop: 8 }}>{renderTimeLineItems()}</Timeline>
      </Col>
      <Col flex={1}>
        <div>
          <span style={{ fontSize: 18, fontWeight: "bold" }}>Company:</span>
          &nbsp;
          {companyName}
        </div>
        <div>
          <span style={{ fontSize: 18, fontWeight: "bold" }}>Driver:</span>
          &nbsp;
          {`${user?.firstName ?? ""} ${user?.lastName ?? ""}`}
        </div>
      </Col>
    </Row>
  );
};

export default ConfirmForDispatchBody;
